<template>
  <div class="text-with-icon">
    <c-icon
      :name="iconName"
      :size="iconSize"
      :color="iconColor"
    />
    <a
      v-if="link"
      :href="link"
      class="text-with-icon__link"
    >
      <slot name="text" />
    </a>
    <c-text
      v-else
      :color="textColor"
      :size="textSize"
      :weight="textWeight"
      :align="textAlign"
      class="text-with-icon__text"
    >
      <slot name="text" />
    </c-text>
  </div>
</template>

<script>

import CIcon from '@ions/icon/icon.vue'
import CText from '@atoms/text/text.vue'

export default {
  name: 'text-with-icon',
  components: { CIcon, CText },
  props: {
    iconName: {
      type: String,
      default: 'headquarter-phone',
    },
    iconSize: {
      type: String,
      default: 'md',
    },
    iconColor: {
      type: String,
      default: 'transparent',
    },
    textColor: {
      type: String,
      default: '#43515A',
    },
    textSize: {
      type: String,
      default: 'lg',
    },
    textWeight: {
      type: String,
      default: '400',
    },
    textAlign: {
      type: String,
      default: 'left',
    },
    link: {
      type: String,
    }
  }
}
</script>

<style lang="scss" scoped>
.text-with-icon {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.5rem;

  &__text {
    color: $neutral-02;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: -0.01em;
    text-align: left;

  }

  &__link {
    @include font-inter(400);
    @extend .text-with-icon__text;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
